import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./styles";
import { useNewOffer } from "../../../js/context/new-offer";
import { intFormat } from "../utils/formats";

export const ItemCardInfoQuantOfferMiles = ({ minMilesAdvanced }) => {
	const { pricesData, currentProgram } = useNewOffer();
	const { minMiles } = pricesData.data;

	return (
		<div
			className={css`
				${defaultStyle}
			`}
		>
			<p className="title">Quantidade de milhas da sua oferta</p>
			<p>Informe quanto você quer receber por cada 1.000 milhas na MaxMilhas.</p>
			<p>
				A quantidade mínima para essa oferta é de {intFormat(minMiles || 0)} milhas, combinado? Lembrando
				que você pode ofertar o máximo de milhas que você tem no seu programa de fidelidade.
			</p>
			{currentProgram.international === "0" &&
				<p>
					Se sua oferta for maior do que {intFormat(minMilesAdvanced)} milhas, você pode utilizar o botão{" "}
					Configurações Avançadas, que aparecerá na sua tela, para definir a média de milhas por passageiro.
					É esta média que vai determinar as emissões de passagens que serão feitas pela MaxMilhas.
				</p>
			}
		</div>
	);
};
